// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`TicketDashboardAssets/styles/_ticket-details-dashboard-main.scss`));
}

function getImage(name) {
  var requireImage = (function(name){
        return require(`TicketDashboardAssets/images/${name}`).default
      });
  return requireImage(name);
}

export {
  importCss ,
  getImage ,
  
}
/* No side effect */
